import { createContext, useContext } from 'react';
import { ResourceTypes } from '../../constants/resourceTypes';

const ScopedEmbeddedViewContext = createContext<{
  isScopedEmbedded: true;
  scopedResource: string;
  scopedRecordId: string;
  scopedParentRecordId: string;
  scopedParentResource: ResourceTypes;
} | { isScopedEmbedded: false }>({ isScopedEmbedded: false });

export const useScopedEmbeddedViewContext = () => {
  const context = useContext(ScopedEmbeddedViewContext);
  return context;
};

export const ScopedEmbeddedViewContextProvider = ScopedEmbeddedViewContext.Provider;
